import React, { useEffect } from 'react';
import { redirectToInvoice } from '../../../usecases/documents-usecase';
import { Cloud } from 'lucide-react';
import "./style.css"

function RedirectQrInvoice() {

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const id = params.get('id');
    if (id) {
      redirectToInvoice(id).then((redirect) => {
        if (redirect){
          window.location.replace("https://catalogo-vpfe.dian.gov.co/User/SearchDocument?DocumentKey="+redirect);
        }
        //window.open(redirect, '_blank');
      }).catch((err) => {
        console.log("")
      })
    }
  }, []);

  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <Cloud className="cloud"/>
      <h2>Documento en proceso</h2>
      <p>Lo sentimos, la página que buscas no existe.</p>
    </div>
  );
}

export default RedirectQrInvoice;
